import React, { useState, useEffect, useMemo } from "react";
import {
  Dialog as FluentDialog,
  Text,
  Button,
  Input,
  Form,
  FormInput,
  Loader,
  EditIcon,
  TrashCanIcon,
  Checkbox,
  Datepicker,
  Card,
  CardBody,
  CardHeader,
  DownloadIcon
} from "@fluentui/react-northstar";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { AddIcon, SearchIcon, CloseIcon } from "@fluentui/react-icons-northstar";
import { WindowContext } from "../../shared/contexts/Context";
import SettingsService from "../../services/settingsservice";
import { process } from "@progress/kendo-data-query";
import { OPERATIONSTATUS } from '../../shared/appcomponents/enums';
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import debounce from 'lodash.debounce';
import { RenderTooltipCell } from "../../shared/appcomponents/TooltipWithCopy";

const SettingsServiceAlertLogs = (props) => {
  const [appRegistration, setAppRegistration] = useState([]);
  const [appRegData, setAppRegData] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [visible, setVisible] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isAppNameValid, setIsAppNameValid] = useState(true);
  const [isObjectIdValid, setIsObjectIdValid] = useState(true);
  const [isAppNameDisabled, setIsAppNameDisabled] = useState(false);
  const [openDeleteConfirmationDialog, setDeleteConfirmationDialog] = useState(false);
  const [deleteAppRegistrationObj, setDeleteAppRegistrationObj] = useState(null);
  const [dataState, setDataState] = useState({
    sort: [{ field: "Id", dir: "desc" }],
    take: 10,
    skip: 0,
    filter: {
      logic: "or",
      filters: [],
    },
  });
  const [isSaving, setIsSaving] = useState(false);
  const [downloading, setDownloading] = React.useState(false);
  const[downloadingMap, setDownloadingMap] = React.useState({});
  useEffect(() => {
    fetchAppRegistrations();
  }, []);

  const fetchAppRegistrations = () => {
    props.acquireToken((token) => {
      if (token) {
        SettingsService.GetServiceAlertLogs(token).then((response) => {
          if (response && response.status === 200) {            
            setAppRegistration(response.data);
            setIsLoaded(true);
          } else {
            props.viewStatus.InformChildPageStatus(response.status || 500);
            setIsLoaded(true);
          }
        }).catch(error => {
          console.error("Error fetching app registrations:", error);
          setIsLoaded(true);
        });
      }
    });
  };

  const filterGridData = (value) => {
    let filter = {
      logic: "or",
      filters: [
        { field: "LogFileDate", operator: "contains", value: value },     
        { field: "LogFileName", operator: "contains", value: value },              
      ],
    };
    setDataState({ ...dataState, filter: filter,skip: 0 });
  };

  const handleAddEditClickOpen = (dataItem, isEdit) => {
    setIsAppNameValid(true);
    setIsObjectIdValid(true);
    setVisible(true);

    if (isEdit && dataItem) {
      setAppRegData({
        ...dataItem,
        ExpiryDate: dataItem.ExpiryDate ? new Date(dataItem.ExpiryDate) : new Date(),
      });
      setEditMode(true);
      setIsAppNameDisabled(true);
    } else {
      setAppRegData({
        Id: 0,
        AppName: "",
        ObjectId: "",
        TenantId: "",
        SecretId: "",
        ExpiryDate: new Date(),
        IsActive: false,
      });
      setEditMode(false);
      setIsAppNameDisabled(false);
    }
  };

  const handleAddEditClickClose = () => {
    setVisible(false);
    setAppRegData(null);
    setEditMode(false);
    setIsAppNameValid(true);
    setIsObjectIdValid(true);
  };

  //const handleDeleteClickOpen = (dataItem) => {
  //  setDeleteAppRegistrationObj(dataItem);
   // setDeleteConfirmationDialog(true);
  //};
  const handleDownloadClick = (dataItem) => {
    //setDeleteAppRegistrationObj(dataItem);
    //setDeleteConfirmationDialog(true);
    //alert(dataItem.LogFileName); 
    let servicelogFileName = dataItem.LogFileName;
    let _params = {
		 				serviceLogFile: servicelogFileName,
		 			};
          setDownloading(true);
          setDownloadingMap((prevState) => ({
                ...prevState,
                [dataItem.Id]: true
            }));
   props.acquireToken((token) => { 
            SettingsService.DownloadServiceAlertLog(token,_params)
                .then((response) => {
                    if (response.status === 200) {
                        const blob = new Blob([response.data], { type: 'text/csv' });
                        const url = URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', servicelogFileName);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else {
                        console.error('Error downloading CSV:', response.statusText);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                })
                .finally(() => {
                    //setDownloading(false);
                    // Set loading to false after download completes
                setDownloadingMap((prevState) => ({
                    ...prevState,
                    [dataItem.Id]: false
                }));
                });
        });


  };

  const handleDeleteClose = () => {
    setDeleteConfirmationDialog(false);
    setDeleteAppRegistrationObj(null);
  };

  const validateForm = () => {
    let isValid = true;
    
    if (!appRegData?.AppName?.trim()) {
      setIsAppNameValid(false);
      isValid = false;
    } else {
      setIsAppNameValid(true);
    }

    if (!appRegData?.ObjectId?.trim()) {
      setIsObjectIdValid(false);
      isValid = false;
    } else {
      setIsObjectIdValid(true);
    }

    return isValid;
  };

  const handleSave = () => {
    if (!validateForm()) return;
    if (isSaving) return;
    
    setIsSaving(true);
    
    props.acquireToken((token) => {
      const serviceCall = editMode
        ? SettingsService.UpdateAppRegistration(appRegData, token)
        : SettingsService.AddAppRegistration(appRegData, token);
        
      serviceCall.then((response) => {
        if (response && response.status === 200) {
          fetchAppRegistrations();
          handleAddEditClickClose();
          props.viewStatus.DisplayOperationStatus(OPERATIONSTATUS.Success);
        } else {
          props.viewStatus.DisplayOperationStatus(response.status || 500);
        }
      }).catch((error) => {
        console.error("Error saving app registration:", error);
        props.viewStatus.DisplayOperationStatus(500);
      }).finally(() => {
        setIsSaving(false);
      });
    });
  };

  const handleDelete = () => {
    props.acquireToken((token) => {
      SettingsService.DeleteAppRegistration(deleteAppRegistrationObj.Id, token)
        .then((response) => {
          if (response && response.status === 200) {
            // Only refresh grid after successful deletion
            fetchAppRegistrations();
            props.viewStatus.DisplayOperationStatus(OPERATIONSTATUS.Success);
          } else {
            props.viewStatus.DisplayOperationStatus(response.status || 500);
          }
        })
        .catch((error) => {
          console.error("Error deleting app registration:", error);
          props.viewStatus.DisplayOperationStatus(500);
        })
        .finally(() => {
          handleDeleteClose();
        });
    });
  };

  const processedData = useMemo(() => process(appRegistration, dataState), [appRegistration, dataState]);

  const handleToggleChange = (dataItem) => {
    const updatedAppReg = { ...dataItem, IsActive: !dataItem.IsActive };
    props.acquireToken((token) => {
      SettingsService.UpdateAppRegistration(updatedAppReg, token)
        .then((response) => {
          if (response && response.status === 200) {
            fetchAppRegistrations();
            props.viewStatus.DisplayOperationStatus(OPERATIONSTATUS.Success);
          } else {
            props.viewStatus.DisplayOperationStatus(response.status || 500);
          }
        })
        .catch((error) => {
          console.error("Error updating app registration:", error);
          props.viewStatus.DisplayOperationStatus(500);
        });
    });
  };

  //const handleDateChange = (e) => { alert(e.value);
   // setAppRegData({ ...appRegData, ExpiryDate: e.value });
 // };

  const handleDateChange = (e, data) => {
    const localDate = new Date(data.value);
    alert(data.value);
    //setCertificateData({ ...certificateData, ExpiryDate: localDate });
    setAppRegData({ ...appRegData, ExpiryDate: data.value });
  };

  const handleSaveDebounced = debounce(handleSave, 300);

  const CellCheckboxEnabledDisabled = (props1) => {
      const dataItem = props1.dataItem;
      return (
        <td style={{ textAlign: "center" }}>
          <Checkbox
            toggle
            checked={dataItem.IsProduction}
            onClick={(event, isChecked) => {
              dataItem.IsProduction =  isChecked.checked;
              props.acquireToken((token) =>
                authSuccessUpdateTogglesCallback(token, dataItem)
              
              );
            }}
          />
        </td>
      );
    };
    const authSuccessUpdateTogglesCallback = (token, data) => {
      const updatedAppReg = { ...data, IsProduction: data.IsProduction };
    if (token) {
      SettingsService.UpdateAppRegProduction(updatedAppReg,token).then((response) => {
        if (response && response.status == 200) {
          response = response.data;
          //props.acquireToken(authSuccessCallback);
          //fetchAppRegistrations();
          props.viewStatus.DisplayOperationStatus(OPERATIONSTATUS.Success);
        } else if (response && response.status == 401) {
          props.viewStatus.DisplayOperationStatus(OPERATIONSTATUS.Unauthorized);
        }
        else {
          props.viewStatus.DisplayOperationStatus(OPERATIONSTATUS.Failed);
        }
      });
    }
  };
    
  const CellDownloadAWS = (props) => {
      //const data = props.dataItem;
      //const uniqueKey = `${props.dataIndex}-${data.MessageId}-${data.MailTimestamp}`; // Include row index, MessageId, and MailTimestamp
      //const isDownloading = downloadingMap[uniqueKey];
      const isDownloading = downloadingMap[props.dataItem.Id];
      
      return (
          <td>
              {
                  isDownloading ? (
                      <Loader size="smallest" />
                  ) : (
                      <Button 
                          content="Download" 
                          onClick={() => handleDownloadClick(props.dataItem)} 
                          icon={<DownloadIcon size="medium" className='mr-1' />} 
                      />
                  )
              }
          </td>
      );
  };

  return isLoaded ? (
    <WindowContext.Consumer>
      {(context) => (
        <div className="row h-100">
          <div className="col-md-12 h-100">
            <Card className="card-border bg-white h-100" fluid>
              <CardHeader className="mb-2">
                <div className="d-flex justify-content-between">
                  <div className="f-size-18">Service Alert Logs</div>
                  {props.user?.Permissions?.some((p) => p === "Settings.ReadWrite" || p === "Settings.Configuration.ReadWrite") && (
                    <Button
                      icon={<AddIcon />}
                      iconPosition="before"
                      content="Add App Registration"
                      primary
                      onClick={() => handleAddEditClickOpen(null, false)}
                      className="ml-auto"
                      style={{display:"none"}}
                    />
                  )}
                </div>
              </CardHeader>
              <CardBody>
                <div className="tbl-search float-right text-right mb-2">
                  <Input
                    onChange={(e) => filterGridData(e.target.value)}
                    inverted
                    icon={<SearchIcon />}
                    placeholder="Search..."
                    className="border-gray"
                  />
                </div>
                <div className="grid-with-search">
                  <Grid
                    style={{ height: "100%" }}
                    pageable={{ buttonCount: 3 }}
                    sortable={true}
                    data={processedData.data}
                    total={processedData.total}
                    skip={dataState.skip}
                    take={dataState.take}
                    sort={dataState.sort}
                    onDataStateChange={(e) => {
                      setDataState(e.dataState);
                    }}
                  >
                    <Column field="LogFileDate" title="Log File Date" width="200px" cell={RenderTooltipCell}/>
                    <Column field="LogFileName" title="Log File Name" width="200px" cell={RenderTooltipCell}/>
                    <Column field="LogFileName" title="Download" cell={CellDownloadAWS} width={110}  />
                    {/* <Column
                      field="IsActive"
                      title="Active"
                      width="100px"
                      cell={(props) => (
                        <td style={{ textAlign: "center" }}>
                          <Checkbox
                            toggle
                            checked={props.dataItem.IsActive}
                            onChange={() => handleToggleChange(props.dataItem)}
                          />
                        </td>
                      )}
                    /> */}
                    
                    
                  </Grid>
                </div>
              </CardBody>
            </Card>
          </div>
          
          {/* Add/Edit Dialog */}
          {visible && (
            <Dialog
              className="k-dialog-md"
              title={editMode ? "Edit App Registration" : "Add App Registration"}
              onClose={handleAddEditClickClose}
            >
              <Form>
                <FormInput
                  label={isAppNameValid ? "App Name" : <Text color="red" content="App Name Required" />}
                  required
                  id="appName"
                  fluid
                  value={appRegData?.AppName || ""}
                  onChange={(e) => {
                    setAppRegData({ ...appRegData, AppName: e.target.value });
                    setIsAppNameValid(e.target.value.trim() !== "");
                  }}
                  error={!isAppNameValid}
                  disabled={isAppNameDisabled}
                  placeholder="App Name"
                />
                <FormInput
                  label={isObjectIdValid ? "Object ID" : <Text color="red" content="Object ID Required" />}
                  required
                  id="objectId"
                  fluid
                  value={appRegData?.ObjectId || ""}
                  onChange={(e) => {
                    setAppRegData({ ...appRegData, ObjectId: e.target.value });
                    setIsObjectIdValid(e.target.value.trim() !== "");
                  }}
                  error={!isObjectIdValid}
                  placeholder="00000000-0000-0000-0000-000000000000"
                />
                <FormInput
                  label="Tenant ID"
                  id="tenantId"
                  fluid
                  value={appRegData?.TenantId || ""}
                  onChange={(e) => {
                    setAppRegData({ ...appRegData, TenantId: e.target.value });
                  }}
                  placeholder="00000000-0000-0000-0000-000000000000"
                />
                <FormInput
                  label="Secret ID"
                  id="secretId"
                  fluid
                  value={appRegData?.SecretId || ""}
                  onChange={(e) => {
                    setAppRegData({ ...appRegData, SecretId: e.target.value });
                  }}
                  placeholder="Secret identifier"
                />
                <div><label>Expiry Date</label>
                                    <Datepicker
                                      label="Expiry Date"
                                      value={appRegData?.ExpiryDate ? new Date(appRegData.ExpiryDate) : new Date()}
                                      onDateChange={handleDateChange}
                                    />
                                  </div>
                <Checkbox
                  label="Active"
                  checked={appRegData?.IsActive || false}
                  onChange={(e, data) => {
                    setAppRegData({ ...appRegData, IsActive: data.checked });
                  }}
                  toggle
                />
                <DialogActionsBar>
                  <button
                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                    onClick={handleSaveDebounced}
                    disabled={isSaving}
                  >
                    {isSaving ? "Saving..." : "Submit"}
                  </button>
                  <button
                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                    onClick={handleAddEditClickClose}
                  >
                    Close
                  </button>
                </DialogActionsBar>
              </Form>
            </Dialog>
          )}
          
          {/* Delete Confirmation Dialog */}
          <FluentDialog
            cancelButton="Cancel"
            confirmButton="Confirm"
            onCancel={handleDeleteClose}
            onConfirm={handleDelete}
            open={openDeleteConfirmationDialog}
            backdrop
            header="Confirm Deletion"
            headerAction={{
              icon: <CloseIcon />,
              title: "Close",
              onClick: handleDeleteClose,
            }}
            content={`Are you sure you want to delete app registration "${deleteAppRegistrationObj?.AppName}"?`}
          />
        </div>
      )}
    </WindowContext.Consumer>
  ) : (
    <Loader />
  );
};

export { SettingsServiceAlertLogs };